import { RelativeDateTimeUtc } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { Card, CardContent, Divider, Stack } from '@optimus-web/core';
import { CardHeader } from '../common';
import { ValueItem } from './components';
import { useGuestValue } from './hooks';

export const GuestValueSection = ({ guestId }: { guestId: string }) => {
    const { data, isFetching } = useGuestValue(guestId);

    return (
        <Card>
            <CardContent padding="200">
                <CardHeader title={lt('Insights')} value={4} />
            </CardContent>
            <Divider />
            <CardContent padding="200">
                <Stack spacing="100" vertical>
                    <ValueItem
                        title={lt('GuestLTValueTotalPastStaysLabel')}
                        value={data?.totalStays}
                        isLoading={isFetching}
                    />
                    <ValueItem
                        title={lt('GuestLTValueTotalNightsSpentLabel')}
                        value={data?.totalNightsSpent}
                        isLoading={isFetching}
                    />
                    <ValueItem
                        title={lt('GuestLTValueTotalAmountSpentLabel')}
                        value={data?.totalAmountSpent}
                        isLoading={isFetching}
                    />
                    <ValueItem
                        title={lt('GuestLTValueLastStayEndedLabel')}
                        value={data?.lastStayDate ? <RelativeDateTimeUtc utcString={data?.lastStayDate} /> : null}
                        isLoading={isFetching}
                    />
                </Stack>
            </CardContent>
        </Card>
    );
};
